export default {
  getCollections: 'collections/GET_COLLECTIONS',
  getCollectionsSuccess: 'collections/GET_COLLECTIONS_SUCCESS',
  getCollectionsFailure: 'collections/GET_COLLECTIONS_FAILURE',

  getCollection: 'collections/GET_COLLECTION',
  getCollectionSuccess: 'collections/GET_COLLECTION_SUCCESS',
  getCollectionFailure: 'collections/GET_COLLECTION_FAILURE',

  getPageCollections: 'collections/GET_PAGE_COLLECTIONS',
  getPageCollectionsSuccess: 'collections/GET_PAGE_COLLECTIONS_SUCCESS',
  getPageCollectionsFailure: 'collections/GET_PAGE_COLLECTIONS_FAILURE',

  getEntries: 'collections/GET_ENTRIES',
  getEntriesSuccess: 'collections/GET_ENTRIES_SUCCESS',
  getEntriesFailure: 'collections/GET_ENTRIES_FAILURE',

  update: 'collections/UPDATE',
  updateSuccess: 'collections/UPDATE_SUCCESS',
  updateFailure: 'collections/UPDATE_FAILURE',
};
